
    import './styles.scoped.css';
    export default {
  "item-element": "awsui_item-element_93a1u_16nhw_145",
  "disabled": "awsui_disabled_93a1u_16nhw_157",
  "show-divider": "awsui_show-divider_93a1u_16nhw_164",
  "highlighted": "awsui_highlighted_93a1u_16nhw_167",
  "is-focused": "awsui_is-focused_93a1u_16nhw_182",
  "visual-refresh": "awsui_visual-refresh_93a1u_16nhw_185",
  "menu-item": "awsui_menu-item_93a1u_16nhw_189",
  "link-style": "awsui_link-style_93a1u_16nhw_201",
  "current-breadcrumb": "awsui_current-breadcrumb_93a1u_16nhw_237",
  "link-style-highlighted": "awsui_link-style-highlighted_93a1u_16nhw_245",
  "has-category-header": "awsui_has-category-header_93a1u_16nhw_251",
  "item-tooltip-wrapper": "awsui_item-tooltip-wrapper_93a1u_16nhw_251",
  "has-checkmark": "awsui_has-checkmark_93a1u_16nhw_251",
  "icon": "awsui_icon_93a1u_16nhw_255",
  "checkmark": "awsui_checkmark_93a1u_16nhw_259",
  "external-icon": "awsui_external-icon_93a1u_16nhw_266"
};
  